import { Box, BoxProps } from 'reflexbox';
import styled from 'styled-components';
import { Skeleton } from './Skeleton';

const ParagraphSkeleton = styled(Skeleton.DynamicBox)<{ lines?: number }>`
	height: ${(props) => (props.lines ?? 2) * 24}px;
`;

export const Paragraph = Skeleton(
	styled(Box)<{ color?: string }>`
		color: ${(props) => props.theme.colors[props.color ?? 'slateBlue']};
		font-size: 15px;
		line-height: 24px;
		font-family: ${(props) => props.theme.fontFamilies.paragraph};

		a {
			color: inherit;

			:hover {
				text-decoration: none;
			}
		}
	`,
	(props: BoxProps & { lines?: number; maxWidth?: number }) => <ParagraphSkeleton {...props} />,
);

export const UnderlineLink = styled.a`
	color: ${(props) => props.theme.colors.primary} !important;
	text-decoration: underline;
	:hover {
		text-decoration: none;
	}
`;

export const Ellipsis = styled(Box)`
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
`;

const TitleSkeleton = styled(Skeleton.DynamicBox)`
	height: 32px;
`;

export const Title = Skeleton(
	styled(Box)`
		color: black;
		font-size: 26px;
		font-weight: bold;
		line-height: 32px;
		font-family: ${({ theme }) => theme.fontFamilies.heading};
	`,
	(props: BoxProps) => <TitleSkeleton {...props} />,
);

const HeadingSkeleton = styled(Skeleton.DynamicBox)`
	height: 24px;
`;

export const Heading = Skeleton(
	styled(Box)`
		color: black;
		font-size: 16px;
		font-weight: bold;
		line-height: 24px;
		font-family: ${({ theme }) => theme.fontFamilies.heading};
	`,
	(props: BoxProps) => <HeadingSkeleton {...props} />,
);

const SubheadingSkeleton = styled(Skeleton.DynamicBox)`
	height: 22px;
`;

export const Subheading = Skeleton(
	styled(Box)`
		color: black;
		font-size: 14px;
		font-weight: bold;
		line-height: 22px;
		font-family: ${({ theme }) => theme.fontFamilies.heading};
	`,
	(props: BoxProps) => <SubheadingSkeleton {...props} />,
);

export const Label = Skeleton(
	styled(Box)`
		color: ${(props) => props.theme.colors.slateBlue};
		font-size: 14px;
		line-height: 20px;
		font-family: ${({ theme }) => theme.fontFamilies.paragraph};
	`,
	styled(Skeleton.DynamicBox)`
		height: 20px;
	`,
);

export const UnorderedList = styled.ul`
	margin-top: 0;

	li {
		margin-left: 15px;
		padding: 2px 0;
	}
`;

export const OrderedList = styled.ol`
	margin-top: 0;

	li {
		margin-left: 15px;
	}
`;
